/* eslint-disable import/first */
import React, { useState } from 'react';
import { useNavigate } from '@reach/router';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
/* eslint-disable import/first */
import { Redux, Slices } from 'spwa-ui-library';
const { useSelector } = Redux;
import Divider from '@material-ui/core/Divider';
const { selectStoreById } = Slices.storeSlice;
import { AiOutlineRight } from '@react-icons/all-files/ai/AiOutlineRight';
import { generateStoreRoute } from 'spwa-ui-library/esm/utils/path';
import { FormattedMessage, useIntl } from 'react-intl';
import css from './index.module.scss';
import { StoreLocatorIcon } from '../../../components/Icons';
import StoreLocatorPlaceOrder from '../../../components/StoreLocatorPlaceOrder';

function StoreItem({ storeId, disablePlaceOrder }) {
  const navigate = useNavigate();
  const store = useSelector((state) => selectStoreById(state, storeId));
  const intl = useIntl();
  const [popup, setPopup] = useState(false);
  const { startTime = '', endTime = '' } = store || null;
  const storeName = 'name_' + intl.locale.toLowerCase();
  const storeAddress = 'address_' + intl.locale.toLowerCase();
  var d = new Date(startTime); /* midnight in China on April 13th */
  const startStore = d.toLocaleTimeString('en-US', {
    timeZone: 'UTC',
    hour: '2-digit',
    minute: '2-digit',
  });

  var end = new Date(endTime); /* midnight in China on April 13th */
  const endStore = end.toLocaleTimeString('en-US', {
    timeZone: 'UTC',
    hour: '2-digit',
    minute: '2-digit',
  });
  const path = generateStoreRoute(store[storeName]);
  const handleStoreNavigate = (event) => {
    event.preventDefault();
    navigate(`/${intl.locale}${path}/${store.storeId}`);
  };
  const handlePlaceOrderPop = () => setPopup(true);
  if (!store) {
    return '';
  }
  return (
    <>
      <div className={css.root}>
        <div className={css.inner}>
          <div className={css.icon}>
            <StoreLocatorIcon />
          </div>
          <div className={css.desc}>
            <Typography variant="h3">{store[storeName]}</Typography>
            <Typography variant="body1">{store[storeAddress]}</Typography>
            <Typography variant="h5">
              <FormattedMessage
                id={`carhop_openinghours`}
                values={{
                  startTime: startStore,
                  endTime: endStore,
                }}
              />
            </Typography>
          </div>
        </div>
        <Divider orientation="horizontal" />
        <div className={css.actionButton}>
          <Button
            variant="contained"
            color="primary"
            disabled={Boolean(disablePlaceOrder)}
            onClick={handlePlaceOrderPop}
          >
            <FormattedMessage id="storeLocator_placeOrder" defaultValue="Place Order" />
          </Button>
          <Button
            href={`/${intl.locale}${path}/${store.storeId}`}
            variant="outlined"
            className={css.viewStore}
            color="secondary"
            endIcon={<AiOutlineRight />}
            onClick={handleStoreNavigate}
          >
            <FormattedMessage id="view_details" defaultValue="View Details" />
          </Button>
        </div>
      </div>
      {popup && <StoreLocatorPlaceOrder setOpen={setPopup} isOpen={popup} storeId={storeId} />}
    </>
  );
}

export default StoreItem;
